import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient,  HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ModalModule } from 'ngx-bootstrap';

import { TeamSummaryService } from './team-summary.service';
import { TeamId2teamNameDirective, RoleId2roleNameDirective } from '../../../directives';
import { CustomInterceptor } from './../../../helper';

// Routing
import { UserRoutingModule } from './user-routing.module';

import { SharedModule } from '../../shared';
import { UserAddComponent, UserAddService } from './user-add';
import { UserEditComponent, UserEditService } from './user-edit';
import { UserDetailComponent, UserDetailService, UserUpdateStatusService } from './user-detail';
import { UserSummaryComponent, UserSummaryService } from './user-summary';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    
    UserRoutingModule,
    ModalModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ReactiveFormsModule,
    SharedModule
  ],
  declarations: [
    UserAddComponent,
    UserEditComponent,
    UserDetailComponent,
    UserSummaryComponent,
    TeamId2teamNameDirective,
    RoleId2roleNameDirective
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    UserAddService,
    UserEditService,
    UserSummaryService,
    UserDetailService,
    UserUpdateStatusService,
    TeamSummaryService,
    { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptor, multi: true }
  ]
})
export class UserModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/user/user.module.ts